import { type App } from 'vue';
import { registerPartials } from '@precon-tools-suite-by-shared/vue-partials';
// Import the global options.

import { type AdminMaintenanceGlobalOptions } from './options';

// Export the
export type { AdminMaintenanceGlobalOptions };
export { default as routes } from './routes';

// The definition of the plugin that installs the
export default {
    install(app: App) {
        registerPartials(
            app,
            {
                // LicensesCountPanel: () =>
                // import('./partials/MaintenanceControl1.vue'),
            },
            '@precon-tools-suite-by-shared/admin-maintenance-feature-control/partials/'
        );
    },
};
